import moment, { version } from 'moment'
import { API_URL } from 'state/api'
import { formatByTimeZone } from 'utils'

export const getFileExtension = filename => {
	const re = /(?:\.([^.]+))?$/

	let extension = re.exec(filename)

	if (extension && extension[1]) {
		return extension[1].toLowerCase()
	} else {
		return null
	}
}

export const isValidFile = (file, format, size = null) => {
	const extension = getFileExtension(file.filename ? file.filename : file.name)

	let isValidExtension = false
	let response = null

	let isValid = true

	switch (format) {
		case 'image':
			switch (extension) {
				case 'jpg':
				case 'jpeg':
				case 'png':
				case 'gif':
					isValidExtension = true
					break
			}
			break
	}

	if (!isValidExtension) {
		isValid = false
		response = "That's not a supported format."
	}

	if (size) {
		if (file.size > (size * 1000000)) {
			isValid = false
			response = "Please upload an image below " + size + "mb in size."
		}
	}

	return {
		isValid,
		response
	}
}

export const getFileDisplayData = fileName => {
	const extension = getFileExtension(fileName)

	let iconName
	let fileTaxonomy = 'file'
	let fileArticle = 'a'

	const lowerCaseExtension = extension ? extension.toLowerCase() : ''

	switch (lowerCaseExtension) {
		case 'pdf':
			iconName = 'file-pdf-o'
			fileTaxonomy = 'document'
			break
		case 'xlsx':
		case 'xlsm':
		case 'xltx':
		case 'xltm':
		case 'xls':
		case 'numbers':
			iconName = 'file-excel-o'
			fileTaxonomy = 'document'
			break
		case 'mp3':
		case 'wav':
		case 'aiff':
		case 'ogg':
		case 'm4a':
			iconName = 'file-audio-o'
			break
		case 'docx':
		case 'doc':
		case 'docm':
			iconName = 'file-word-o'
			fileTaxonomy = 'document'
			break
		case 'pages':
			iconName = 'file-text-o'
			fileTaxonomy = 'document'
			break
		case 'ppt':
		case 'pttx':
		case 'pptm':
		case 'potx':
		case 'potm':
			iconName = 'file-powerpoint-o'
			fileTaxonomy = 'document'
			break
		case 'css':
		case 'sass':
		case 'scss':
		case 'js':
		case 'jsx':
		case 'html':
		case 'php':
		case 'cs':
		case 'xml':
		case 'sql':
		case 'asp':
		case 'cpp':
		case 'py':
		case 'jsp':
		case 'cgi':
		case 'pl':
		case 'aspx':
		case 'java':
			iconName = 'file-code-o'
			fileTaxonomy = 'script'
			break
		case 'zip':
		case 'rar':
		case 'tar':
			iconName = 'file-archive-o'
			fileArticle = 'an'
			fileTaxonomy = 'archive'
			break
		case 'mp4':
		case 'avi':
		case 'mov':
		case 'mpeg':
		case 'mpeg2':
		case 'webm':
			iconName = 'file-video-o'
			fileTaxonomy = 'video'
			break
		case 'psd':
		case 'svg':
			iconName = 'file-photo-o'
			break
		case 'png':
		case 'jpg':
		case 'jpeg':
		case 'gif':
		case 'bmp':
			iconName = 'file-photo-o'
			fileArticle = 'an'
			fileTaxonomy = 'image'
			break
		default:
			iconName = 'file-o'
			break
	}

	return {
		icon: iconName,
		taxonomy: fileTaxonomy,
		article: fileArticle,
		extension
	}
}

export const parseFileArray = (files, callback) => {
	let allResults = []
	let incrementer = 0

	files.forEach((file, index) => {
		let reader = new FileReader()

		if (file) {
			reader.onloadend = _ => {
				incrementer += 1
				allResults[index] = {
					object: file,
					previewUrl: reader.result
				}

				if (incrementer == files.length) {
					callback(allResults)
				}
			}

			reader.readAsDataURL(file)
		}
	})
}

export const eventContainsFiles = event => {
	if (event.dataTransfer.types) {
		for (var i = 0; i < event.dataTransfer.types.length; i++) {
			if (event.dataTransfer.types[i] == "Files") {
				return true
			}
		}
	}

	return false
}

export const getFileFromCamera = (uploadFile, user) => {
	navigator.camera.getPicture(response => {
		const base64String = 'data:image/jpeg;base64,' + response
		let blobData = dataURItoBlob(base64String)

		blobData.name = `Photo from ${user.first_name}'s phone, ${moment().format('YYYY-MM-DD HH:mm:ss')}`

		uploadFile([{
			object: blobData,
			previewUrl: base64String
		}])
	}, _ => { }, {
		destinationType: navigator.camera.DestinationType.DATA_URL,
		correctOrientation: true
	})
}

export const dataURItoBlob = dataURI => {
	var byteString;
	if (dataURI.split(',')[0].indexOf('base64') >= 0)
		byteString = atob(dataURI.split(',')[1])
	else
		byteString = unescape(dataURI.split(',')[1])

	var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

	var ia = new Uint8Array(byteString.length)
	for (var i = 0; i < byteString.length; i++) {
		ia[i] = byteString.charCodeAt(i)
	}

	return new Blob([ia], { type: mimeString })
}

export const getDownloadUrl = version => {
	if (version.hashedId) {
		return `${API_URL}/files/download/${version.hashedId}`
	}
	
	return API_URL + '/files/download/' + version.id
}

export const forceDownload = version => {
	const anchor = document.createElement('a')
	anchor.href = getDownloadUrl(version)
	anchor.target = "_blank"

	document.body.appendChild(anchor)
	anchor.click()
	// anchor.remove()
}

export const formatFileSize = version => {
	if (!version.size) {
		return null
	}

	// over 1mb
	if (version.size > 999999) {
		const sizeInMb = (version.size / 1000000)

		return (Math.round(sizeInMb * 100) / 100) + 'mb'
	} else {
		const sizeInKb = (version.size / 1000)
		return (Math.round(sizeInKb * 100) / 100) + 'kb'
	}
}

export const minutesSinceCreation = version => {
	const createdAtDateToCompare = formatByTimeZone(version.created_at, null, true)
	const minutesSinceCreation = moment().diff(createdAtDateToCompare, 'minutes')

	return minutesSinceCreation
}

export const hasFailed = version => {
	return (!version.url && minutesSinceCreation(version) > 5)
}